export default "__VITE_ASSET__DkuhazyT__"